/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AccountStatusGet = {
    ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED',
    ACCOUNT_COLLECTION: 'ACCOUNT_COLLECTION',
    ACCOUNT_OK: 'ACCOUNT_OK',
    ACCOUNT_TO_CLOSE: 'ACCOUNT_TO_CLOSE',
    ACCOUNT_CLOSED: 'ACCOUNT_CLOSED',
    ACCOUNT_AUTO_CLOSED: 'ACCOUNT_AUTO_CLOSED'
} as const;

export type AccountStatusGet = typeof AccountStatusGet[keyof typeof AccountStatusGet];



